import { createAction } from '@ngrx/store';

export const enterAction = createAction('[Climate Zone Modal] Enter');
